import { mfOfflineHandling } from '@fe-toolkit/utility/modern/client'

// Module Federation runtime plugin: graceful degradation when the fe-common
// remote is unavailable (offline, DNS failure, timeout, unreachable manifest).
//
// This file loads inside the federation-runtime bootstrap, so it MUST stay
// React-free. The fallbacks are provided as dynamic imports so the feds-ui
// Header/Footer chunk is fetched ONLY on failure — never bundled into the
// bootstrap (which previously caused a "Cannot read properties of undefined
// (reading 'call')" crash when React leaked into it).
//
// Exported as a factory: @module-federation/modern-js-v3 calls the default
// export to obtain the plugin instance.
export default () =>
  mfOfflineHandling({
    // Fail fast if the remote is slow, so SSR/TTFB can't stall on a hung fetch.
    timeoutMs: 3000,
    // On load failure the full-nav FallbackHeader/FallbackFooter render in place
    // of the remote, receiving the same props the remote was given (e.g.
    // username). They pick feds-ui's or the legacy Header and Footer from the
    // layout's chrome flags, and are shared with the FederatedComponentBoundary
    // fallbacks in layout.tsx, so the degraded UI is identical whichever failure
    // mode fires. See docs/fallback-header-footer.md.
    fallbacks: {
      'fe_common/components/CommonHeader': () => import('@/components/fallbacks/FallbackHeader').then((m) => m.default),
      'fe_common/components/CommonFooter': () => import('@/components/fallbacks/FallbackFooter').then((m) => m.default),
    },
  })
